<script>
/**
 * MobileBottomNav — navegação inferior fixa (estilo app nativo), só no mobile.
 * Links para as telas principais de cada módulo. Escondido no desktop e
 * quando um chat de grupo está em fullscreen (body.grupos-chat).
 */
export default {
  name: 'MobileBottomNav',
  data() {
    return {
      itens: [
        { to: '/app/dashboard', icon: 'ri-dashboard-2-line', label: 'Dashboard' },
        { to: '/app/atendimento', icon: 'ri-chat-3-line', label: 'Conversas' },
        { to: '/app/grupos', icon: 'ri-group-line', label: 'Grupos' },
        { to: '/app/canais', icon: 'ri-broadcast-line', label: 'Notícias' },
      ],
    };
  },
};
</script>

<template>
  <nav class="mobile-bottom-nav">
    <router-link
      v-for="item in itens"
      :key="item.to"
      :to="item.to"
      class="mbn-item"
      active-class="mbn-item--ativo"
    >
      <i :class="item.icon"></i>
      <span class="mbn-label">{{ item.label }}</span>
    </router-link>
  </nav>
</template>

<style scoped>
.mobile-bottom-nav {
  display: none; /* só aparece no mobile (media query abaixo) */
  position: fixed;
  left: 0; right: 0; bottom: 0;
  z-index: 1035;
  height: 58px;
  padding-bottom: env(safe-area-inset-bottom, 0); /* iOS notch */
  /* Cores da topbar: vermelho no light, vermelho escuro no dark. */
  background: var(--vz-primary, #971219);
  border-top: 1px solid rgba(0, 0, 0, 0.18);
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.12);
}
[data-bs-theme='dark'] .mobile-bottom-nav {
  background: var(--brand-primary-dark, #3f060a);
  border-top-color: rgba(0, 0, 0, 0.35);
}
.mbn-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  text-decoration: none;
  /* Acento da marca, esmaecido quando inativo (color-mix segue a cor do tema). */
  color: color-mix(in srgb, var(--vz-yellow, #fff100) 70%, transparent);
  font-size: 0.68rem;
  padding: 6px 0 4px;
  transition: color 0.12s;
}
.mbn-item i { font-size: 1.35rem; line-height: 1; }
.mbn-item--ativo { color: var(--vz-yellow, #fff100); font-weight: 600; }
/* Dark: --vz-yellow já vira o acento-dark da marca via <style id="brand-vars">. */
[data-bs-theme='dark'] .mbn-item { color: color-mix(in srgb, var(--vz-yellow, #f2c94c) 70%, transparent); }
[data-bs-theme='dark'] .mbn-item--ativo { color: var(--vz-yellow, #f2c94c); }

@media (max-width: 767.98px) {
  .mobile-bottom-nav { display: flex; }
  /* Conversa em fullscreen (grupo/canal/atendimento): sem a barra (o composer fica no rodapé). */
  body.grupos-chat .mobile-bottom-nav,
  body.canais-chat .mobile-bottom-nav,
  body.atendimento-chat .mobile-bottom-nav { display: none; }
}
</style>
